import { render, staticRenderFns } from "./agentdetails.vue?vue&type=template&id=501f9946&scoped=true&"
import script from "./agentdetails.vue?vue&type=script&lang=js&"
export * from "./agentdetails.vue?vue&type=script&lang=js&"
import style0 from "./agentdetails.vue?vue&type=style&index=0&id=501f9946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501f9946",
  null
  
)

export default component.exports